import { Moment } from 'moment';

import { makeMoment } from '../Model';
import { MemberWarning } from './MemberWarning';

export class MemberWarningCCMReconsent extends MemberWarning {
  lastConsentAt?: Moment;

  lastConsentBy?: string;

  currentNP?: string;

  constructor(obj: any) {
    super(obj);
    Object.assign(this, obj);
    this.lastConsentAt = makeMoment(obj.lastConsentAt);
  }
}

export default MemberWarningCCMReconsent;
